/* istanbul ignore file */
import {
  deleteDataDogCookies,
  getDataDogLoggerOptions,
} from '../../features/tracking/trackers/datadog';
import { initLogger } from '@doxyme/analytics';

export const initializeLogger = (): void => {
  deleteDataDogCookies();
  initLogger(getDataDogLoggerOptions());
};
